import React, { Component } from "react";
import NavBar from "../Componentes/NavBar";
import Tabs from "../Componentes/Tabs";
import AgregaFoto from "../Componentes/AgregaFotos";
import Grid from "@material-ui/core/Grid";
import fire from "../config/Fire";
import "./Eventos.css";
import FadeIn from "react-fade-in";
import Album from "../Componentes/album";

class fotos extends Component {
  constructor() {
    super();
    this.state = {
      pictures: []
    };
  }
  componentDidMount() {
    fire.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({ pictures: [] });
        fire
          .database()
          .ref()
          .child("Album")
          .on("child_added", snapshot => {
            this.setState({
              pictures: this.state.pictures.concat(snapshot.key)
            });
          });
      }
    });
  }
  render() {
    return (
      <div>
        <NavBar />
        <Tabs />
        <FadeIn>
          <div className="content">
            <Grid container spacing={40} alignItems="center">
              <Grid item xs={12}>
                <AgregaFoto />
              </Grid>
            </Grid>
            <Grid container spacing={24} alignItems="center">
              {this.state.pictures.map(card => {
                return (
                  <Grid item sm={6} md={4} lg={3}>
                    <Album titulo={card} />
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </FadeIn>
      </div>
    );
  }
}

export default fotos;
